import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/(public)/")({
  beforeLoad: ({ context: { store } }) => {
    if (!store.getState().isAuthenticated) {
      throw redirect({ to: "/login" })
    }

    switch (store.getState().userRole) {
      case "customer":
        throw redirect({ to: "/home" })
      case "lender":
        throw redirect({ to: "/lender" })
      case "partner":
        throw redirect({ to: "/partners" })
      case "staff":
        // Staff lives in a separate SPA mounted at /staff/, so use a
        // full-document redirect instead of an in-app route transition.
        throw redirect({ href: "/staff/", reloadDocument: true })
      default:
        throw Error("User Role not supported.")
    }
  },
})
